import { HTTPClient, AxiosResponse } from "@abaco/web-common/src/HTTP";
import { Competence, CompetenceBulkResult, CompetenceObj, CompetenceSingleResult } from "./models/Competence";

export default class CompetencesResources{

    constructor(private http: HTTPClient){}

    public async checkBulkCompetencesForUser(competences: Competence[]){
        const url = `/sitiagri-rest-api/api_basic/v1/user_registry/module_competencies_bulk`;
        return this.executeCheck(url, competences);
    }

    public async checkBulkCompetenceForPkcuaa(competences: Competence[], pkCuaa: number): Promise<CompetenceObj> {
        const url = `/sitiagri-rest-api/api_basic/v1/user_registry/subjects/${pkCuaa}/module_competencies_bulk`
        return this.executeCheck(url, competences);
    }

    private async executeCheck(url: string, competences: Competence[]) {
        const res = await this.http.post(url, competences);
        const map: CompetenceObj = {};

        res.data.forEach((competence: CompetenceBulkResult) => {
            map[`${competence.software}|${competence.module}`] = competence.authorised
        });
        return map;
    }

    public async setCompetencesForUser(competences: Competence[]): Promise<CompetenceSingleResult[]> {
        const res: Promise<AxiosResponse>[] = [];

        competences.forEach(p => {
            res.push(this.http.post(`/sitiagri-rest-api/api_basic/v1/user_registry/module_competencies/`, p))
        })

        return (await Promise.all(res)).map((r, i: number) => ({module: competences[i].module, result: r.data.result}));
    }

    public async setCompetencesForPkcuaa(competences: Competence[] ,pkCuaa: number): Promise<CompetenceSingleResult[]> {
        const res: Promise<AxiosResponse>[] = [];

        competences.forEach(p => {
            res.push(this.http.post(`/sitiagri-rest-api/api_basic/v1/user_registry/subjects/${pkCuaa}/module_competencies/`, p))
        })

        return (await Promise.all(res)).map((r, i: number) => ({module: competences[i].module, result: r.data.result}));
    }

    public async deleteCompetencesForPkcuaa(competences: Competence[], pkCuaa: number){
        const res: Promise<AxiosResponse>[] = [];

        competences.forEach(p => {
            res.push(this.http.delete(`/sitiagri-rest-api/api_basic/v1/user_registry/subjects/${pkCuaa}/module_competencies/${p.software}/${p.module}`))
        })

        return (await Promise.all(res)).map((r, i: number) => ({module: competences[i].module, result: r.data.result}));
    }

    public async deleteCompetencesForUser(competences: Competence[]){
        const res: Promise<AxiosResponse>[] = [];

        competences.forEach(p => {
            res.push(this.http.delete(`/sitiagri-rest-api/api_basic/v1/user_registry/module_competencies/${p.software}/${p.module}`))
        })

        return (await Promise.all(res)).map((r, i: number) => ({module: competences[i].module, result: r.data.result}));
    }
}